<template>
    <div class="free-plan-success">
        <div class="logo-wrapper">
            <img :src="CloudWebSvg" v-if="isCloudPlan">
            <span class="icon icon-co_success_blue" v-else>
                <span class="path1"></span>
                <span class="path2"></span>
            </span>
        </div>
        <div class="content-wrapper">
            <h1 class="content-title">{{ title }}</h1>
            <take-effect-tip
                class="send-email"
                :plan-type="planType"
            />
            <p class="send-email" v-html="$t('switch_plan.contact_us_renew', lang, { link: config.support_team })"></p>
            <slot name="associated-failed"></slot>
        </div>
    </div>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue';
import { config } from 'CONFIG';
import CloudWebSvg from '@/common/images/common/others/co_cloudweb.png';
import { ESeriesCategory, ESubscribeMode } from '@reolink-cloud/interface';
import TakeEffectTip from './components/TakeEffectTip.vue';

export default Vue.extend({
    components: {
        TakeEffectTip
    },
    props: {
        mode: {
            type: String,
            required: true
        },
        planType: String as PropType<ESeriesCategory>
    },
    data() {

        return {
            config,
            ESubscribeMode,
            CloudWebSvg
        };

    },
    computed: {
        lang(): string {

            return this.$store.getters.lang;

        },
        title(): string {

            return ( this.mode === ESubscribeMode.RENEW ?
                this.$t( 'switch_plan.renewal_free' ) :
                this.$t( 'switch_plan.open_free' )) as string;

        },
        isCloudPlan(): boolean {

            return this.planType === ESeriesCategory.CLOUD_STORAGE_PLAN;

        }
    }
});
</script>

<style lang="less" scoped>
    .free-plan-success{
        width: 600px;
        margin: 0 auto;
        text-align: center;
        @media @snapeak_mobile{
            width: unset;
        }
        .logo-wrapper{
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: 12px;
            img{
                width: 100px;
                height: 100px;
            }
            .icon{
                color: @b_6;
                font-size: 58px;
            }
        }
        .content-wrapper{
            .content-title{
                font-family: @font_01;
                font-size: 32px;
            }
            .send-email{
                margin-top: 16px;
                font-size: 16px;
                font-weight: 500;
                color: @font_secondary;
            }
        }
    }
</style>
